import { render, staticRenderFns } from "./ussdCampaignForm.vue?vue&type=template&id=f4c07238&scoped=true&"
import script from "./ussdCampaignForm.vue?vue&type=script&lang=js&"
export * from "./ussdCampaignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c07238",
  null
  
)

export default component.exports